import { useState } from "react";
import { ImageOff } from "lucide-react";

interface CoverImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  /** Extra classes for the fallback placeholder div. Defaults to matching the img className. */
  fallbackClassName?: string;
}

/**
 * Renders a cover/cover-art image with a graceful fallback placeholder when the
 * image fails to load (corrupted base64, truncated data, generation error, etc.).
 */
export function CoverImageWithFallback({
  src,
  alt,
  className = "",
  fallbackClassName,
}: CoverImageWithFallbackProps) {
  const [error, setError] = useState(false);

  if (error) {
    const placeholderClass = fallbackClassName ?? className;
    return (
      <div
        className={`flex flex-col items-center justify-center gap-2 bg-gray-100 border border-dashed border-gray-300 rounded-lg text-gray-400 text-xs text-center p-4 ${placeholderClass}`}
        title={`Could not load image: ${alt}`}
      >
        <ImageOff className="h-8 w-8 text-gray-300" />
        <span>Image unavailable</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setError(true)}
    />
  );
}
